import React from 'react';
import cx from 'classnames';
import {Flex, Text, Dropdown} from '@priority-software/priority-style-react';
import {formatServerDate} from '@priority-software/priority-utils/lib/date';
import {highlightText} from '../../library/utils/highlightText';
import {getDefaultDateFormat} from '../../../Localization/date';
import styles from '../styles/QuickSearch.module.scss';

interface QuickSearchItemProps {
    item: any;
    isLastIndex: boolean;
    index: number;
    onClick: (zoomValue) => void;
    query: string;
}

/**
 *
 * @param item
 * @param isLastIndex
 * @param index
 * @param onClick
 *
 */
export const QuickSearchItem = ({
    item,
    query,
    isLastIndex,
    index,
    onClick
}: QuickSearchItemProps) => {
    const {ac_text1, name, statdes, curdate} = item;
    const dateFormat = getDefaultDateFormat();
    const date = formatServerDate(curdate, dateFormat);
    const middleTextsKeysArray = Object.keys(item).filter(key => key.includes('rg_text'));

    return (
        <Dropdown.Item
            key={index}
            index={index}
            divider={!isLastIndex}
            onClick={() => onClick(name)}
            componentClasses={styles.item}
        >
            <Flex componentClasses={styles.fullWidth} paddingTop>
                {ac_text1 && (
                    <Text
                        componentClasses={cx(styles.label, styles.margin)}
                        textColor="primary-700"
                        skin="subtitle-2"
                    >
                        {highlightText(ac_text1, query)}
                    </Text>
                )}
                {date && (
                    <Text componentClasses={styles.label} textColor="primary-700" skin="subtitle-2">
                        {date}
                    </Text>
                )}
            </Flex>

            <Flex
                justifyContent="flex-start"
                componentClasses={cx(styles.fullWidth, styles.breakLine)}
            >
                {middleTextsKeysArray.map((itemKey, i) => (
                    <>
                        {i > 0 && (
                            <Text
                                skin="subtitle-2"
                                textColor="primary-700"
                                componentClasses={styles.bullet}
                            >
                                {'\u2022'}
                            </Text>
                        )}

                        {item[itemKey] && (
                            <Text
                                componentClasses={styles.label}
                                textColor="primary-700"
                                skin="subtitle-2"
                            >
                                {highlightText(item[itemKey], query)}
                            </Text>
                        )}
                    </>
                ))}
            </Flex>

            <Flex componentClasses={styles.fullWidth} paddingBottom>
                {name && (
                    <Text
                        textColor="secondary-400"
                        skin="label-1"
                        componentClasses={cx(styles.label, styles.margin)}
                    >
                        {highlightText(name, query)}
                    </Text>
                )}

                {statdes && (
                    <Text
                        skin="label-1"
                        textColor="secondary-400"
                        componentClasses={cx(styles.label)}
                    >
                        {statdes}
                    </Text>
                )}
            </Flex>
        </Dropdown.Item>
    );
};
